var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      color: "#89A6FF"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99935 3.9987V1.33203L4.66602 4.66536L7.99935 7.9987V5.33203C10.206 5.33203 11.9993 7.12536 11.9993 9.33203C11.9993 11.5387 10.206 13.332 7.99935 13.332C5.79268 13.332 3.99935 11.5387 3.99935 9.33203H2.66602C2.66602 12.2787 5.05268 14.6654 7.99935 14.6654C10.946 14.6654 13.3327 12.2787 13.3327 9.33203C13.3327 6.38536 10.946 3.9987 7.99935 3.9987Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.6dd6a9c8b6bd7ed1d916ea47415c015f.svg";
export { ForwardRef as ReactComponent };